var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { "data-test": _vm.CypressTarget("MyAddresses"), padding: "" } },
    [
      _c(
        "q-item",
        { staticClass: "col-12" },
        [
          _c(
            "q-card",
            {
              staticClass: "full-width myAddress-group",
              class: { "bg-white": true },
              attrs: { "data-test": _vm.CypressTarget("ProductGroup") }
            },
            [
              _c(
                "q-card-title",
                {
                  style: { "padding-bottom": "0px" },
                  attrs: { "data-test": _vm.CypressTarget("Title") }
                },
                [
                  _c("div", { staticClass: "cart-event-group-header-cols" }, [
                    _c(
                      "div",
                      {
                        class: { "cart-event-group-header-col-a": true },
                        style: { "font-size": "12pt" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("label.myAddresses")) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                ]
              ),
              _c(
                "q-card-main",
                {
                  staticClass: "no-padding",
                  attrs: { "data-test": _vm.CypressTarget("MyAddresses") }
                },
                [
                  _vm.myAddresses.length === 0
                    ? _c("q-item", [
                        _c(
                          "span",
                          { staticClass: "q-subheading q-mx-auto text-grey" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("label.delivery.noAddressFound")) +
                                "..."
                            )
                          ]
                        )
                      ])
                    : _vm._l(_vm.myAddresses, function(address) {
                        return _c(
                          "q-item",
                          { key: address.id, staticClass: "myAddress" },
                          [
                            _c("q-item-main", [
                              _c("div", [
                                _c("b", { staticClass: "q-ml-sm" }, [
                                  _vm._v(_vm._s(address.alias))
                                ])
                              ]),
                              _c("div", { staticClass: "q-ml-sm" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(address.address) +
                                    ",\n              " +
                                    _vm._s(address.address_number) +
                                    ",\n              " +
                                    _vm._s(
                                      address.complement
                                        ? address.complement + ", "
                                        : ""
                                    ) +
                                    "\n              " +
                                    _vm._s(address.city) +
                                    " -\n              " +
                                    _vm._s(address.state) +
                                    "\n            "
                                )
                              ])
                            ]),
                            _c(
                              "q-item-side",
                              { attrs: { right: "" } },
                              [
                                _c(
                                  "q-btn",
                                  {
                                    attrs: {
                                      flat: "",
                                      color: "primary",
                                      rounded: "",
                                      size: "sm",
                                      title: _vm.$t(
                                        "label.delivery.addressEditTitle"
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.showAlert(
                                          _vm.MODAL_TYPE.EDIT_ADDRESS,
                                          address
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-edit",
                                      staticStyle: {
                                        "font-size": "1.2em !important"
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "q-btn",
                                  {
                                    attrs: {
                                      flat: "",
                                      color: "primary",
                                      rounded: "",
                                      size: "sm",
                                      title: _vm.$t(
                                        "label.delivery.addressDeleteTitle"
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.showAlert(
                                          _vm.MODAL_TYPE.DELETE_ADDRESS,
                                          address
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-trash",
                                      staticStyle: {
                                        "font-size": "1.2em !important"
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-item",
        [
          _c(
            "q-item-main",
            { staticClass: "text-center" },
            [
              _vm.myAddresses.length < _vm.MAX_ADDRESS_COUNT
                ? _c("q-btn", {
                    staticClass: "q-mr-none",
                    attrs: {
                      "data-test": _vm.CypressTarget("NewAddress"),
                      label: _vm.$t("button.newAddress"),
                      color: "primary",
                      rounded: "",
                      flat: ""
                    },
                    on: {
                      click: function($event) {
                        _vm.editAddress(null)
                      }
                    }
                  })
                : _c("span", { staticClass: "text-grey" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("text.checkout.delivery.maxAddress", {
                            qty: _vm.MAX_ADDRESS_COUNT
                          })
                        ) +
                        "\n      "
                    )
                  ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            minimized: "",
            "content-classes": "q-pa-md",
            "content-css": "max-width: 600px"
          },
          model: {
            value: _vm.show_alert,
            callback: function($$v) {
              _vm.show_alert = $$v
            },
            expression: "show_alert"
          }
        },
        [
          _c(
            "div",
            { staticClass: "row justify-center exclamation text-red-12" },
            [
              _c("i", {
                staticClass: "fa fa-exclamation-triangle fa-4x padding-bottom"
              }),
              _vm._v("\n      " + _vm._s(_vm.$t("label.attention")) + "\n    ")
            ]
          ),
          _c("div", { staticClass: "row justify-center padding-bottom" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("dialog.myAddresses.alert")) + "\n    "
            )
          ]),
          _c(
            "div",
            { staticClass: "row justify-center" },
            [
              _c("q-btn", {
                attrs: { flat: "", label: _vm.$t("button.cancel") },
                on: {
                  click: function($event) {
                    _vm.show_alert = false
                  }
                }
              }),
              _c("q-btn", {
                attrs: { color: "primary", label: _vm.$t("button.agreed") },
                on: {
                  click: function($event) {
                    _vm.callModal()
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "q-modal",
        {
          attrs: {
            minimized: "",
            "content-classes": "q-pa-md",
            "content-css": "max-width: 600px"
          },
          model: {
            value: _vm.show_address_dialog,
            callback: function($$v) {
              _vm.show_address_dialog = $$v
            },
            expression: "show_address_dialog"
          }
        },
        [
          _c("div", { staticClass: "q-title q-mb-md" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.editing_address.id !== -1
                    ? _vm.editing_address.alias
                    : _vm.$t("button.newAddress")
                ) +
                "\n    "
            )
          ]),
          _c(
            "div",
            { staticClass: "q-mb-md" },
            [
              _c(
                "q-field",
                {
                  attrs: {
                    "data-test": _vm.CypressTarget("AddressName"),
                    error: _vm.$v.editing_address.alias.$error,
                    "error-label": _vm.$t("error.required.field", {
                      field: _vm.$t("field.delivery.alias")
                    })
                  }
                },
                [
                  _c("q-input", {
                    ref: "addressName",
                    attrs: {
                      id: "addressName",
                      "data-test": _vm.CypressTarget("Input"),
                      "float-label": _vm.$t("field.delivery.alias"),
                      color: _vm.SET_COLOR_BUTTON.primary,
                      "text-color": _vm.SET_COLOR_BUTTON.text.primary,
                      type: "text",
                      maxlength: "255"
                    },
                    model: {
                      value: _vm.editing_address.alias,
                      callback: function($$v) {
                        _vm.$set(_vm.editing_address, "alias", $$v)
                      },
                      expression: "editing_address.alias"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            [
              _vm.editing_address.id === -1 &&
              _vm.getUserAddress.country === _vm.BRAZIL
                ? _c(
                    "q-field",
                    {
                      staticClass: "q-mb-sm",
                      attrs: {
                        "data-test": _vm.CypressTarget("useBuyerAddress")
                      }
                    },
                    [
                      _c("q-checkbox", {
                        ref: "useBuyerAddress",
                        attrs: {
                          id: "useBuyerAddress",
                          "data-test": _vm.CypressTarget("Input"),
                          label: _vm.$t("text.myAddresses.useBuyerAddress"),
                          color: _vm.SET_COLOR.primary
                        },
                        model: {
                          value: _vm.use_buyer_address,
                          callback: function($$v) {
                            _vm.use_buyer_address = $$v
                          },
                          expression: "use_buyer_address"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            [
              _c("brazilian-address-form", {
                key: _vm.address_key,
                ref: "addressForm",
                attrs: {
                  value: _vm.editing_address,
                  "can-edit": !_vm.use_buyer_address,
                  "fields-settings": Object.assign({}, _vm.address_settings),
                  "lock-country": ""
                },
                on: {
                  input: function($event) {
                    _vm.editing_address = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "row justify-end" },
            [
              _c("q-btn", {
                attrs: { flat: "", label: _vm.$t("button.cancel") },
                on: {
                  click: function($event) {
                    _vm.cancelAddressEdit()
                  }
                }
              }),
              _c("q-btn", {
                attrs: { color: "primary", label: _vm.$t("button.save") },
                on: { click: _vm.save }
              })
            ],
            1
          ),
          _c("q-inner-loading", {
            attrs: { visible: _vm.saving_address, color: "primary" }
          })
        ],
        1
      ),
      _c("q-inner-loading", {
        attrs: { visible: _vm.saving_address || _vm.saving, color: "primary" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }